import { createApi } from '@reduxjs/toolkit/query/react';
import { CmsContentApiVersions } from '../cms-content-api-service';
import { getBaseQuery } from '../cms-content-api-service-redux';
export const additionalPageContentApi = createApi({
    reducerPath: 'additionalPageContentApi',
    baseQuery: getBaseQuery,
    endpoints: builder => ({
        getAdditionalPageContent: builder.query({
            query: ({ languageCode }) => ['additionalpagecontent', { languageCode }, CmsContentApiVersions.V2],
        }),
    }),
});
export const { useGetAdditionalPageContentQuery } = additionalPageContentApi;
